import { useCallback } from 'react'

import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { openContentFromStageTile } from '@/actions'
import {
  analyticsVideoTypes,
  eventAction,
  eventObject,
  videoPlayerNames,
} from '@/constants/analytics'
import { useOpenTile } from '@/hooks/useOpenTile'
import useStore from '@/store/useStore'
import { StageSlide } from '@/types/servicesTypes/configTypes'
import { sendAnalyticsEvent } from '@/utils/analyticsUtils'

export const useOpenStageTileContent = () => {
  const setIsFullscreen = useStore((state) => state.player.setIsFullscreen)
  const openEvent = useOpenTile()

  return useCallback(
    (stageSlide: StageSlide) => {
      const { type } = stageSlide

      const channel = stageSlide.channel
      const channelVideo = channel?.video
      const channelUrl = channelVideo?.sources?.[0]?.url
      const media = stageSlide.media
      const mediaVideo = media?.video
      const mediaUrl = channelVideo?.sources?.[0]?.url

      switch (type) {
        case 'Page':
          if (stageSlide.page && stageSlide.pageLink) {
            openContentFromStageTile(stageSlide, openEvent)
          }
          break

        case 'Event':
          openContentFromStageTile(stageSlide, openEvent)
          break

        case 'Channel':
          isDevMode &&
            console.log('[Stage] onFooterButtonClick open in fullscreen', type)
          setIsFullscreen(true)

          sendAnalyticsEvent({
            object: eventObject.VIDEO,
            action: eventAction.FULLSCREEN_CLICK,
            video: {
              id: channel?.id,
              link: channelUrl,
            },
          })
          sendAnalyticsEvent({
            object: eventObject.VIDEO,
            action: eventAction.START_CLICK,
            video: {
              id: channel?.id || stageSlide.id,
              name: channel?.name || stageSlide.title || stageSlide.id,
              playerName: videoPlayerNames.HLS,
              type: analyticsVideoTypes.STREAM,
              link: channelUrl,
              partnerIds: channel?.partnerIds,
            },
          })
          break

        case 'Media':
          isDevMode &&
            console.log('[Stage] onFooterButtonClick open in fullscreen', type)
          setIsFullscreen(true)

          sendAnalyticsEvent({
            object: eventObject.VIDEO,
            action: eventAction.FULLSCREEN_CLICK,
            video: {
              id: mediaVideo?.id,
              link: mediaUrl,
            },
          })
          sendAnalyticsEvent({
            object: eventObject.VIDEO,
            action: eventAction.START_CLICK,
            video: {
              id: mediaVideo?.id || stageSlide.id,
              name: stageSlide.title || stageSlide.id,
              playerName: videoPlayerNames.HLS,
              type: analyticsVideoTypes.VOD,
              link: mediaUrl,
              partnerIds: media?.partnerIds,
            },
          })
          break

        case 'Promotion':
          if (stageSlide.promotion?.page) {
            openContentFromStageTile(stageSlide, openEvent)
          }
          break

        default:
          break
      }
    },
    [openEvent, setIsFullscreen],
  )
}
